export default "__VITE_ASSET__Do_UFETY__"